import styled from "styled-components"

const BlogWrapper = styled.div``

export default BlogWrapper
